import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const EbanxResultMob = () => {
  return <CommonResult />;
};

export default EbanxResultMob;
